export default {"src":"/_next/static/media/global-coverage.ab786a82.svg","height":32,"width":32};